import { useEffect, useState } from "react";
import "./ProductCard.css";
import { fileURL } from "../../utils/fileURL";
import { formatearPrecio } from "../../utils/moneda";
import { isFavorite, toggleFavorite } from "../../utils/favorites";

function ProductCard({ data, onClick, configuracionTienda }) {
  const imageUrl = data?.url_image ? fileURL(data.url_image) : null;

  const productoId = data?.producto_id;
  const [fav, setFav] = useState(false);

  useEffect(() => {
    if (productoId == null) return undefined;
    const sync = () => setFav(isFavorite(productoId));
    sync();
    window.addEventListener("favorites:updated", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("favorites:updated", sync);
      window.removeEventListener("storage", sync);
    };
  }, [productoId]);

  const handleToggleFav = (e) => {
    e.stopPropagation();
    if (!data) return;
    const nowFav = toggleFavorite(data);
    setFav(nowFav);
  };

  const enOferta = Boolean(data?.en_oferta);

  const priceText =
    formatearPrecio(data?.precio_unitario, configuracionTienda, {
      espacioEntreSimbolo: true,
    }) || "—";

  const offerPriceText =
    formatearPrecio(data?.precio_efectivo, configuracionTienda, {
      espacioEntreSimbolo: true,
    }) || "—";

  const isOutOfStock = Number(data?.cantidad_disponible) === 0;

  const handleOpen = () => {
    if (isOutOfStock) return;
    if (typeof onClick === "function") onClick();
  };

  return (
    <div className="product-card-scope">
      <div
        className={`product-card ${isOutOfStock ? "product-card--disabled" : ""}`}
        role="button"
        tabIndex={isOutOfStock ? -1 : 0}
        onClick={handleOpen}
        onKeyDown={(e) => {
          if ((e.key === "Enter" || e.key === " ") && !isOutOfStock) {
            e.preventDefault();
            handleOpen();
          }
        }}
      >
        <div className="product-card__image-wrap">
          {enOferta && (
            <span className="product-card__offer-badge">
              −{data?.descuento_porcentaje}%
            </span>
          )}

          <button
            type="button"
            className={`product-card__fav ${
              fav ? "product-card__fav--active" : ""
            }`}
            onClick={handleToggleFav}
            aria-pressed={fav}
            aria-label={
              fav ? "Quitar de favoritos" : "Agregar a favoritos"
            }
            title={fav ? "Quitar de favoritos" : "Agregar a favoritos"}
          >
            <svg
              viewBox="0 0 24 24"
              fill={fav ? "currentColor" : "none"}
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z" />
            </svg>
          </button>
          <div className="product-card__image-shell">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={data?.nombre || "Producto"}
                className="product-card__image"
                loading="lazy"
                decoding="async"
              />
            ) : (
              <div className="product-card__no-image">Sin imagen</div>
            )}
          </div>

          <span
            className={`product-card__badge ${
              isOutOfStock
                ? "product-card__badge--out"
                : "product-card__badge--in"
            }`}
          >
            {isOutOfStock ? "Agotado" : "Disponible"}
          </span>
        </div>

        <div className="product-card__body">
          <div className="product-card__content">
            <h3 className="product-card__title">{data?.nombre || "—"}</h3>

            {data?.no_parte ? (
              <p className="product-card__sku">SKU: {data.no_parte}</p>
            ) : (
              <p className="product-card__sku product-card__sku--empty">
                Producto disponible
              </p>
            )}

            {enOferta ? (
              <p className="product-card__price product-card__price--offer">
                <span className="product-card__price-old">{priceText}</span>
                <span className="product-card__price-new">{offerPriceText}</span>
              </p>
            ) : (
              <p className="product-card__price">{priceText}</p>
            )}
          </div>

          <button
            type="button"
            className="product-card__button"
            disabled={isOutOfStock}
            onClick={(e) => {
              e.stopPropagation();
              handleOpen();
            }}
          >
            {isOutOfStock ? "No disponible" : "Ver detalles"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;